import React from 'react';

const ResponsibleGaming = () => {
  return (
    <div className="policy-page">
      <div className="container">
        <div className="policy-header">
          <h1>Responsible Gaming</h1>
          <p>Ensuring a safe and enjoyable gaming experience for everyone.</p>
        </div>

        <div className="policy-content">
          <div className="policy-section">
            <h2>Play Responsibly</h2>
            <p>
              Our social casino games are designed for entertainment purposes only. It is important to play responsibly and understand that success in social casino games does not translate to real money gambling success.
            </p>

            <h2>Responsible Gaming Tips</h2>
            <ul>
              <li>Play for fun, not as a way to make money.</li>
              <li>Set time and spending limits for gaming sessions.</li>
              <li>Take regular breaks and prioritize other activities.</li>
              <li>Never chase losses; gaming should remain an enjoyable experience.</li>
            </ul>

            <h2>Self-Exclusion</h2>
            <p>
              If you feel that gaming is negatively affecting your life, consider taking a break. We offer self-exclusion options that allow you to temporarily or permanently disable your access to our games.
            </p>

            <h2>Need Help?</h2>
            <p>
              If you or someone you know is struggling with gaming addiction, please seek professional help. Here are some organizations that provide support:
            </p>
            <ul>
              <li><a href="https://www.begambleaware.org/" target="_blank" rel="noopener noreferrer">BeGambleAware</a></li>
              <li><a href="https://www.gamblingtherapy.org/" target="_blank" rel="noopener noreferrer">Gambling Therapy</a></li>
              <li><a href="https://www.gamcare.org.uk/" target="_blank" rel="noopener noreferrer">GamCare</a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResponsibleGaming;